import { createElement } from 'react';
import { ActiveRingChart } from '@jiaminghi/data-view-react';
const DataVActiveRingChart = (props) => {
    const { style, ...rest } = props;
    return createElement(ActiveRingChart, { config: rest, style: style });
};
export default DataVActiveRingChart;
